// I 14 allergeni alimentari obbligatori (Reg. UE 1169/2011)
export const ALLERGENS = [
  { key: 'glutine', label: 'Glutine' },
  { key: 'crostacei', label: 'Crostacei' },
  { key: 'uova', label: 'Uova' },
  { key: 'pesce', label: 'Pesce' },
  { key: 'arachidi', label: 'Arachidi' },
  { key: 'soia', label: 'Soia' },
  { key: 'latte', label: 'Latte / Lattosio' },
  { key: 'frutta_guscio', label: 'Frutta a guscio' },
  { key: 'sedano', label: 'Sedano' },
  { key: 'senape', label: 'Senape' },
  { key: 'sesamo', label: 'Sesamo' },
  { key: 'solfiti', label: 'Solfiti' },
  { key: 'lupini', label: 'Lupini' },
  { key: 'molluschi', label: 'Molluschi' },
];

export const ALLERGEN_LABEL = ALLERGENS.reduce((acc, a) => { acc[a.key] = a.label; return acc; }, {});
